import api from "../http";
import {message} from "antd";


/**
 * Проверяет публичность Google документа
 * @param {string} url - URL документа
 * @returns {Promise<boolean>} - true if document is public, false otherwise
 */
export const checkDocumentPublic = async (url) => {
    try {
        const shouldResp = await api.get('supabase/should-validate-document-public', {params: { url }});
        if (shouldResp?.data?.should_validate === false) {
            return false;
        }
        if (shouldResp?.data?.should_validate === true) {
            const precheckResp = await api.get('supabase/precheck-document-public', {params: { url }});
            if (precheckResp?.data?.is_public === true) {
                message.warning({
                    content: 'Document is public! Please close access to your Google Document',
                    duration: 4,
                });
                return true;
            }
        }
        return false;
    } catch (_) {
        console.warn('Public-check: failed — proceeding without blocking');
        return false;
    }
};

/**
 * Проверяет документ на дубликаты
 * @param {Object} params - параметры для проверки
 * @param {string} params.brand_id - ID бренда
 * @param {string} params.date_end - Дата окончания
 * @param {string} params.date_start - Дата начала
 * @param {string} params.department_id - ID департамента
 * @param {string} params.document_type_id - ID типа документа
 * @param {string} params.document_url - URL документа
 * @param {string} params.period_id - ID периода
 * @param {string} params.exclude_document_id - ID документа для исключения (при обновлении)
 * @returns {Promise<boolean>} - true если найдены дубликаты, false если нет
 */
export const checkDocumentDuplicates = async (params) => {

    try {
        const req_body = {
            brand_id: params.brand_id,
            date_end: params.date_end,
            date_start: params.date_start,
            department_id: params.department_id,
            document_type_id: params.document_type_id,
            document_url: params.document_url,
            period_id: params.period_id,
            exclude_document_id: params.exclude_document_id || null
        };

        const response = await api.post('supabase/check-document-duplicates', req_body);

        // Если запрос не успешен
        if (!response.data?.success) {
            console.error('Duplicate check failed:', response.data);
            return false;
        }

        // Если найдены дубликаты
        if (response.data.isUnique === false && response.data.duplicates?.length > 0) {
            return response.data.duplicates
        }

        return false;
    } catch (error) {
        console.error('Error checking duplicates:', error);

        if (error?.response?.data?.message) {
            message.error({
                content: error.response.data.message,
                duration: 3,
            });
        }
        return false;
    }
};

/**
 * Проверяет, нужна ли проверка на дубликаты при обновлении документа
 * @param {Object} currentRow - текущие данные документа
 * @param {Object} initialRow - исходные данные документа
 * @returns {boolean} - true если нужна проверка
 */
export const isDuplicateCheckNeeded = (currentRow, initialRow) => {
    return (
        currentRow.document_url !== initialRow?.document_url ||
        currentRow.brand_id !== initialRow?.brand_id ||
        currentRow.department_id !== initialRow?.department_id ||
        currentRow.period_id !== initialRow?.period_id ||
        currentRow.document_type_id !== initialRow?.document_type_id ||
        currentRow.date_start !== initialRow?.date_start ||
        currentRow.date_end !== initialRow?.date_end
    );
};
